import { Text, View } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';

interface Record {
  value?: string; // 积分
  type?: number; // 收入/支出
  content?: string; // 介绍
  create_time?: string; //时间
}

interface State {
  Records: Record[]
}

export default class ScoresRule extends Base {
  public config: Config = {
    navigationBarTitleText: '积分记录'
  };

  public state: State = {
    Records: []
  };

  public didMount() {
    this.fetchRecord();
  }

  private fetchRecord = async() => {
    const { body: options } = await this.apiClient.base.wxbScoresRecord({
      type:2
    });

    this.setState({
      Records: options
    });
  }

 

  public render() {
    const { Records } = this.state;

    return (
      <View className={styles.container}>
        {Records.map((option, index) => {
          return (
            <View className={styles.list}>
              <View className={styles.left}>
                <Text className={styles.h1}>{option.content}</Text>
                <Text className={styles.h2}>{option.create_time}</Text>
              </View>
              <View className={this.cx(styles.right,option.type == 2 && styles.cut)}>
                {option.type == 1?'+':'-'}{option.value}
              </View>
            </View>
          );
        })}
        {Records.length < 1 && (
          <View className={styles.empty}>暂无数据...</View>
        )}
        
        
      </View>
    );
  }
}
